import { gql } from "@outschool/ui-apollo";

export const LearnersForParentInSectionQuery = gql`
  query LearnersForParentInSection($sectionUid: ID!) {
    learnersForParentInSection(sectionUid: $sectionUid) {
      uid
    }
  }
`;
